"use strict";
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var common_1 = require('@angular/common');
var ng2_redux_1 = require('ng2-redux');
var reducers_1 = require('../reducers');
var store_1 = require('../store');
var RioSampleApp = (function () {
    function RioSampleApp(ngRedux) {
        this.ngRedux = ngRedux;
        ngRedux.configureStore(reducers_1.default, {}, store_1.middleware, store_1.enhancers);
    }
    RioSampleApp = __decorate([
        core_1.Component({
            selector: 'rio-sample-app',
            directives: [router_1.ROUTER_DIRECTIVES],
            pipes: [common_1.AsyncPipe],
            // Allow app to define global styles.
            encapsulation: core_1.ViewEncapsulation.None,
            styles: [require('../styles/index.css')],
            template: require('./sample-app.tmpl.html')
        }), 
        __metadata('design:paramtypes', [ng2_redux_1.NgRedux])
    ], RioSampleApp);
    return RioSampleApp;
}());
exports.RioSampleApp = RioSampleApp;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2FtcGxlLWFwcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNhbXBsZS1hcHAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHFCQUE2RCxlQUFlLENBQUMsQ0FBQTtBQUM3RSx1QkFFTyxpQkFBaUIsQ0FBQyxDQUFBO0FBRXpCLHVCQUEwQixpQkFBaUIsQ0FBQyxDQUFBO0FBRzVDLDBCQUFnQyxXQUFXLENBQUMsQ0FBQTtBQUc1Qyx5QkFBd0IsYUFBYSxDQUFDLENBQUE7QUFDdEMsc0JBQXNDLFVBQVUsQ0FBQyxDQUFBO0FBWWpEO0lBRUUsc0JBQ1UsT0FBMkI7UUFBM0IsWUFBTyxHQUFQLE9BQU8sQ0FBb0I7UUFFbkMsT0FBTyxDQUFDLGNBQWMsQ0FBQyxrQkFBVyxFQUFFLEVBQUUsRUFBRSxrQkFBVSxFQUFFLGlCQUFTLENBQUMsQ0FBQztJQUVqRSxDQUFDO0lBakJIO1FBQUMsZ0JBQVMsQ0FBQztZQUNULFFBQVEsRUFBRSxnQkFBZ0I7WUFDMUIsVUFBVSxFQUFFLENBQUUsMEJBQWlCLENBQUU7WUFDakMsS0FBSyxFQUFFLENBQUUsa0JBQVMsQ0FBRTtZQUNwQixxQ0FBcUM7WUFDckMsYUFBYSxFQUFFLHdCQUFpQixDQUFDLElBQUk7WUFDckMsTUFBTSxFQUFFLENBQUUsT0FBTyxDQUFDLHFCQUFxQixDQUFDLENBQUU7WUFDMUMsUUFBUSxFQUFFLE9BQU8sQ0FBQyx3QkFBd0IsQ0FBQztTQUM1QyxDQUFDOztvQkFBQTtJQVVGLG1CQUFDO0FBQUQsQ0FBQyxBQVJELElBUUM7QUFSWSxvQkFBWSxlQVF4QixDQUFBO0FBQUEsQ0FBQyJ9


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/sample-app.ts
 ** module id = 965
 ** module chunks = 1
 **/